const jobs = [
    {
        company: 'Mujin Corp',
        title: 'Software Engineer',
        period: 'Jul 2024 – Present',
        description:
            'At Mujin, I work on backend systems and infrastructure with a strong focus on developing interfaces and C++ components that drive real-world functionality. My work includes designing and building production-level drivers, contributing to system architecture, and ensuring high performance and reliability across the software stack.',
    },
    {
        company: 'Hewlett Packard Enterprise',
        title: 'Software Engineer',
        period: 'Jan 2019 – Jun 2024',
        description:
            'At HPE, I was part of the iLO firmware team for HPE servers, where I worked at the firmware–interface level to develop and enhance platform capabilities. I also contributed to cloud infrastructure components that supported remote server management, diagnostics, and secure provisioning at scale.',
    },
];

export default function Experience() {
    return (
        <section id="experience" className="px-6 py-24 bg-[#0d1117]" data-aos="fade-up">
            <div className="max-w-3xl mx-auto">
                <p className="text-[#f0883e] text-xs mb-2 font-mono tracking-widest uppercase">
                    {'// experience.log'}
                </p>
                <h2 className="text-2xl font-bold text-[#e6edf3] mb-10 font-mono">Experience</h2>

                {/* Timeline */}
                <div className="relative">
                    {/* Vertical line */}
                    <div className="absolute inset-y-0 left-3 w-px bg-[#30363d]" />

                    <div className="space-y-8">
                        {jobs.map((job, i) => (
                            <div key={i} className="relative pl-10">
                                {/* Dot */}
                                <div className="absolute left-3 top-5 -translate-x-1/2 w-3 h-3 rounded-full bg-[#3fb950] border-2 border-[#0d1117]" />

                                {/* Card */}
                                <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-5 hover:border-[#3fb950]/50 transition-colors duration-300">
                                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1 mb-3">
                                        <div>
                                            <p className="text-[#e6edf3] font-semibold font-mono text-sm">
                                                {job.company}
                                            </p>
                                            <p className="text-[#3fb950] text-xs font-mono mt-0.5">
                                                {job.title}
                                            </p>
                                        </div>
                                        <span className="text-[#58a6ff] text-xs font-mono whitespace-nowrap">
                                            {job.period}
                                        </span>
                                    </div>
                                    <p className="text-[#8b949e] text-sm leading-7 font-mono">
                                        {job.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
